<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  platform: {
    type: String,
    required: true,
    validator: v => ['facebook', 'tiktok', 'instagram', 'telegram'].includes(v),
  },
});

const TIKTOK_BUSINESS_SIGNUP_URL = 'https://www.tiktok.com/business/';

const { t } = useI18n();

const title = computed(() =>
  t(`INBOX_MGMT.CHANNEL_NEW_PLATFORM.${props.platform}.TITLE`)
);

const isTiktok = computed(() => props.platform === 'tiktok');

const body = computed(() => {
  if (isTiktok.value) return null;
  return t(`INBOX_MGMT.CHANNEL_NEW_PLATFORM.${props.platform}.BODY`);
});

const tiktokLead = computed(() =>
  isTiktok.value ? t('INBOX_MGMT.CHANNEL_NEW_PLATFORM.tiktok.BODY_LEAD') : ''
);

const signupLabel = computed(() =>
  isTiktok.value ? t('INBOX_MGMT.CHANNEL_NEW_PLATFORM.tiktok.SIGNUP') : ''
);
</script>

<template>
  <div class="flex w-full max-w-3xl flex-col gap-3 text-center">
    <h2 class="mb-0 text-2xl font-bold text-n-slate-12">
      {{ title }}
    </h2>
    <p v-if="body" class="mb-0 text-body-main leading-relaxed text-n-slate-11">
      {{ body }}
    </p>
    <p
      v-else-if="isTiktok"
      class="mb-0 text-body-main leading-relaxed text-n-slate-11"
    >
      {{ tiktokLead }}
      <a
        :href="TIKTOK_BUSINESS_SIGNUP_URL"
        target="_blank"
        rel="noopener noreferrer"
        class="font-medium text-n-blue-11 underline hover:text-n-blue-12"
      >
        {{ signupLabel }}
      </a>
    </p>
  </div>
</template>
